import(/* webpackMode: "eager" */ "/opt/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/packages/ui/src/css/pages/_post.css");
